import React from 'react'
import {createSearchParams, Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import StudentController from "../../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
import PublicSecureAuthorization
    from "../../../../../services/system/secure-authorization/secure-authorization-controller";
import TableHeader from "../../../../../components/TableHeader";
import LinkPlus from "../../../../../components/Link/LinkPlus";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import GradeManager from "../../../../../components/Grade";
import Utils from "../../../../../utils/utils";
import SchoolServiceController from "../../../../../services/system/school-service/school-service-controller";
import PaymentServiceController from "../../../../../services/system/payment-service/payment-service-controller";
import Pagination from "../../../../../components/Pagination";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} />;
}
class CreateInvoiceManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeDate: null,
            studentName: "",
            studentId: -1,
            listStudent: [],
            money: 0,
            note: "",
            pageNumber: 0,
            pageSize: 10,
            pageNumberPayment: 0,
            pageSizePayment: 10,
            totalItemPayment: 0,

            paymentServiceType: "",
            paymentServiceTypeState: "PARTIAL_PAYMENT",
            paymentType: "NHAN_TIEN",
            listServiceRegisteredByStudent: [],
            listPayments: [],

            serviceId: "",
            serviceName: "",
            serviceRegisteredId: "",

            listGroupUser: [],
            listItemInvoice: [],

            headerServices: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên dịch vụ",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "payment",
                    name: "Phí dịch vụ/Hàng hóa",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Thuế",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Phụ phí",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Đã thanh toán",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Còn lại",
                    style: {textAlign: "center"},
                    sort: false
                }
            ],
            headerPayments: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên dịch vụ",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "payment",
                    name: "Phí dịch vụ",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Thuế",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Phụ phí",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Số tiền thanh toán",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "start",
                    name: "Ngày thanh toán",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "end",
                    name: "Chú thích",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Loại thanh toán",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Trạng thái thanh toán",
                    style: {textAlign: "center"},
                    sort: false
                },
            ],

            yearId: parseInt(getSchoolYear()),
            listClassRoom: [],
        };
    }

    componentWillMount() {
        this.getListStudent()
        this.getListGroupUser()
    }
    saveContent(newContent) {
        this.setState({
            content: newContent,
        });
    }
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    getAllClass = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderService() {
        return this.state.listServiceRegisteredByStudent.map((item, index) => <option
            value={item.serviceRegisterId} service-id={item.serviceId} service-name={item.serviceName}  payment-service-type={item.paymentServiceType}>{item.serviceName}</option>)
    }
    onCreate = () => {
        let money = parseInt(this.state.money.toString().replaceAll(",", ""))
        if (isNaN(money)){
            toast.warning("Tiền không đúng định dạng!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (money < 1000){
            toast.warning("Số tiền nộp phải lớn hơn 1000", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (this.state.studentId < 1){
            toast.warning("Vui lòng chọn học sinh", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (this.state.serviceId == ""){
            toast.warning("Vui lòng chọn dịch vụ", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (this.state.serviceRegisteredId == ""){
            toast.warning("Vui lòng chọn dịch vụ", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (this.state.paymentServiceType == ""){
            toast.warning("Vui lòng chọn loại dịch vụ", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let payload = {
                "payment": money,
                "note": this.state.note,
                "paymentServiceType": this.state.paymentServiceType,
                "paymentServiceTypeState": this.state.paymentServiceTypeState,
                "paymentType": this.state.paymentType,
                "serviceRegisteredId": parseFloat(this.state.serviceRegisteredId),
                "serviceId": parseFloat(this.state.serviceId),
                "serviceName": this.state.serviceName,
                "studentId": parseFloat(this.state.studentId),
                "yearId": parseInt(getSchoolYear()),
            }
            PaymentServiceController.create(payload, res => {
                if (res.success){
                    toast.success("Thêm thanh toán thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            if (gradeId === "")
                this.getAllClass()
            else {
                this.getListClass()
            }
        });
    }
    getListClass = () => {
        let payload = {
            name: "",
            grade: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                listClassRoom: res.data.content
            });
        })
    };

    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: this.state.classRoomId,
            grade: this.state.gradeId,
            fullName: this.state.studentName,
            code: "",
            ethnic: "",
            gender: "",
            pageNumber:0,
            pageSize: 100,
            sort: "created_at desc",
            studentState: "",
        };
        StudentController.search(payload, res => {
            this.setState({
                listStudent: res.data.content,
            });
        })
    }
    getListClass() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId,
            name: "",
            pageNumber: 0,
            pageSize: 200,
            sort: "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    }
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getListClass()
        });
    }
    renderClass() {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getListServiceByStudent() {
        if (this.state.studentId < 0){
            toast.error("Vui lòng chọn học sinh");
        }else {
            let payload = {
                yearId: parseInt(getSchoolYear()),
                studentId: parseInt(this.state.studentId),
                "sort": "created_at desc"
            };
            SchoolServiceController.getAllServiceRegisteredByStudent(payload, res => {
                if (res.success) {
                    this.setState(
                        {
                            listServiceRegisteredByStudent: res.data.schoolServiceItemList
                        }
                    );
                }
            });
        }
    }

    getLinkService(paymentServiceType){
        if (paymentServiceType =="SERVICE_BUS"){
            return "/ad-sas-school/sua-tuyen-xe-bus";
        }else if (paymentServiceType =="SERVICE_CLB"){
            return "/ad-sas-school/chi-tiet-lop-clb"
        }else if (paymentServiceType =="SERVICE_EAT"){
            return ""
        }else if (paymentServiceType =="SERVICE_OTHER"){
            return ""
        }else if (paymentServiceType =="LATE_PICK_UP"){
            return ""
        }else if (paymentServiceType =="FEE"){
            return ""
        }else if (paymentServiceType =="OTHER"){
            return ""
        }
    }

    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListServiceByStudent(this.state.studentId)
            }
        );
    };
    handleChangePagePayment = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListService();
            }
        );
    };
    getListAlPayment() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            studentId: this.state.studentId,
            serviceRegisteredId: this.state.serviceRegisteredId,
            classId: this.state.classId,
            gradeId: this.state.gradeId,
            paymentServiceType: this.state.paymentServiceType,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc"
        };
        PaymentServiceController.allPaymentByStudent(payload, res => {
            this.setState({
                showLoading: false,
                listPayments: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    render() {
        let {gradeId, headerPayments, headerServices} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-invoice" parentClass="wallet-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thêm thanh toán"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>THÊM MỚI THANh TOÁN</h2>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item pl-0">Khối</label>
                                                <GradeManager
                                                    gradeId={gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-4 label-item pl-0">Lớp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.classRoomId}
                                                    onChange={(e) => {
                                                        this.state.classRoomId = e.target.value;
                                                        this.setState({
                                                            classRoomId: e.target.value,
                                                            inEditing: true
                                                        }, () =>{
                                                            this.getListStudent()
                                                        })
                                                    }}
                                                >
                                                    <option value="-1">Chọn lớp</option>
                                                    {this.renderClassRoom()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-4 label-item pl-0">Chọn học sinh</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listStudent}
                                                    getOptionLabel={option => option.fullName?option.fullName:""}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.studentName}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Nhập tên học sinh'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null){
                                                            this.setState({
                                                                studentName: val
                                                            })
                                                            if (val === ""){
                                                                this.state.studentId = -1;
                                                            }
                                                        }
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.id != undefined){
                                                            this.setState({
                                                                studentId: val?.id,
                                                                studentName: val?.fullName,
                                                            }, ()=>{
                                                                this.getListAlPayment();
                                                                this.getListServiceByStudent(this.state.studentId)
                                                            })
                                                        }else {
                                                            this.setState({
                                                                studentId: -1,
                                                                studentName: "",
                                                            })
                                                        }
                                                        // this.getListPeopleInCharge()
                                                    }}

                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-4 label-item pl-0">Loại thanh toán</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.paymentType}
                                                    onChange={(e) => {
                                                        this.state.paymentType = e.target.value;
                                                        this.setState({
                                                            paymentType: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="NHAN_TIEN">Nhận tiền</option>
                                                    <option value="TRA_TIEN">Trả tiền</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-4 label-item pl-0">Trạng thái thanh toán</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.paymentServiceTypeState}
                                                    onChange={(e) => {
                                                        this.state.paymentServiceTypeState = e.target.value;
                                                        this.setState({
                                                            paymentServiceTypeState: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="PARTIAL_PAYMENT">Thanh toán 1 phần</option>
                                                    <option value="COMPLETE">Hoàn thành thanh toán</option>
                                                    <option value="CANCEL">Hủy thanh toán</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-4 label-item pl-0">Loại dịch vụ</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.paymentServiceType}
                                                    onChange={(e) => {
                                                        this.state.paymentServiceType = e.target.value;
                                                        this.setState({
                                                            paymentServiceType: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn loại dịch vụ</option>
                                                    <option value="SERVICE_BUS">Xe bus</option>
                                                    <option value="SERVICE_CLB">Câu lạc bộ</option>
                                                    <option value="SERVICE_EAT">Ăn uống</option>
                                                    <option value="SERVICE_OTHER">Dịch vụ khác</option>
                                                    <option value="LATE_PICK_UP">Đón muộn</option>
                                                    <option value="FEE">Học phí</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-4 label-item pl-0">Chọn dịch vụ thanh toán</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.serviceRegisteredId}
                                                    onChange={(e) => {
                                                        let index = e.target.selectedIndex;
                                                        let optionElement = e.target.childNodes[index]
                                                        let serviceName =  optionElement.getAttribute('service-name')
                                                        let serviceId =  parseInt(optionElement.getAttribute('service-id'))
                                                        let paymentServiceType =  optionElement.getAttribute('payment-service-type')
                                                        let serviceRegisteredId = e.target.value;
                                                        console.log(serviceRegisteredId)
                                                        this.setState({
                                                            serviceId: serviceId,
                                                            serviceName: serviceName,
                                                            serviceRegisteredId: serviceRegisteredId,
                                                            paymentServiceType: paymentServiceType,
                                                        }, () =>{
                                                            this.getListAlPayment()
                                                        })
                                                    }}
                                                >
                                                    <option value="" service-name="" service-id="" payment-service-type ="">Chọn dịch vụ đã đăng ký</option>
                                                    {this.renderService()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-4 label-item pl-0">Số tiền thanh toán</label>
                                                <input
                                                    placeholder="Nhập số tiền"
                                                    name="title"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={Utils.formatMoney(this.state.money)}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            money: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-4 label-item pl-0">Chú thích</label>
                                                <textarea name="note" id="" cols="30" rows="3"
                                                          maxLength="255"
                                                          className="form-control"
                                                          value={this.state.note}
                                                          onChange={e => this.setState({note: e.target.value})}/>
                                            </div>
                                            <div className="align-right col-12">
                                                <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                                    <button
                                                        type="button"
                                                        className="ml-4 col-1 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                                        disabled={this.state.studentId < 1}
                                                        onClick={()=> {
                                                            this.onCreate()
                                                        }}
                                                    >
                                                        Lưu
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="ml-4  border-1-s type-button-fix btn btn-light shadow-none"
                                                    >
                                                        <Link
                                                            style={{color: '#000'}}
                                                            to={{
                                                                pathname: "/ad-sas-school/quan-ly-cac-khoan-thu"
                                                            }}
                                                        >
                                                            Hủy bỏ
                                                        </Link>
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Danh sách các dịch vụ đã đăng ký của học sinh
                                            </div>
                                            <div className="p-0 mb-3">
                                                <div className="table-wrapper">
                                                    <table
                                                        className="table table-striped table-data table-responsive table-bordered">
                                                        <table className="table">
                                                            <thead>
                                                            <TableHeader
                                                                header={headerServices}
                                                            />
                                                            </thead>
                                                            {!this.state.listServiceRegisteredByStudent ||
                                                            this.state.listServiceRegisteredByStudent.length == 0 ? (
                                                                <tbody>
                                                                <tr>
                                                                    <td colSpan={12}>
                                                                        <div className="text-center">
                                                                            Không có dữ liệu
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            ) : (
                                                                <tbody>
                                                                {this.state.listServiceRegisteredByStudent &&
                                                                this.state.listServiceRegisteredByStudent.length > 0 &&
                                                                this.state.listServiceRegisteredByStudent?.map((row, index) => (
                                                                    <tr style={{height: 50}}>
                                                                        <td style={{textAlign: "center"}} scope="row">
                                                                            {" "}
                                                                            {this.state.pageNumber * this.state.pageSize +
                                                                            index +
                                                                            1}
                                                                        </td>
                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                            <LinkPlus
                                                                                target="_blank"
                                                                                style={{color: '#0053ff', textDecoration: 'underline'}}
                                                                                to={{
                                                                                    pathname: this.getLinkService(row.paymentServiceType),
                                                                                    search: createSearchParams({
                                                                                        id: `${row.id}`
                                                                                    }).toString(),
                                                                                    state: {
                                                                                        fromDashboard: true,
                                                                                        id: row.id
                                                                                    }
                                                                                }}
                                                                            >
                                                                                {row.serviceName}
                                                                            </LinkPlus>

                                                                        </td>
                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                            {Utils.formatMoney(row.price)} VNĐ
                                                                        </td>
                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                            {Utils.formatMoney(row.tax)} VNĐ
                                                                        </td>
                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                            {Utils.formatMoney(row.surcharge)} VNĐ
                                                                        </td>
                                                                        <td style={{textAlign: "center"}} scope="row">
                                                                            {Utils.formatMoney(row.totalPayment)} VNĐ                                                                    </td>
                                                                        <td style={{textAlign: "center"}} scope="row">
                                                                            {Utils.formatMoney(row.price+row.tax+row.surcharge-row.totalPayment)} VNĐ
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                                </tbody>
                                                            )}
                                                        </table>
                                                    </table>
                                                </div>
                                                <div className="pagination-right">
                                                    <Pagination
                                                        activePage={this.state.pageNumber}
                                                        itemsCountPerPage={this.state.pageSize}
                                                        totalItemsCount={this.state.totalItem}
                                                        changeHandler={page => this.handleChangePage(page)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Danh sách các thanh toán của học sinh
                                            </div>
                                            <div className="p-0 mb-3">
                                                <div className="table-wrapper">
                                                    <table
                                                        className="table table-striped table-data table-responsive table-bordered">
                                                        <table className="table">
                                                            <thead>
                                                            <TableHeader
                                                                header={headerPayments}
                                                            />
                                                            </thead>
                                                            {!this.state.listPayments ||
                                                            this.state.listPayments.length == 0 ? (
                                                                <tbody>
                                                                <tr>
                                                                    <td colSpan={12}>
                                                                        <div className="text-center">
                                                                            Không có dữ liệu
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            ) : (
                                                                <tbody>
                                                                {this.state.listPayments &&
                                                                this.state.listPayments.length > 0 &&
                                                                this.state.listPayments?.map((row, index) => (
                                                                    <tr style={{height: 50}}>
                                                                        <td style={{textAlign: "center"}} scope="row">
                                                                            {" "}
                                                                            {this.state.pageNumberPayment * this.state.pageSizePayment +
                                                                            index +
                                                                            1}
                                                                        </td>
                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                            {row.serviceName}
                                                                        </td>
                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                            {Utils.formatMoney(row.price)} VNĐ
                                                                        </td>
                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                            {Utils.formatMoney(row.tax)} VNĐ
                                                                        </td>
                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                            {Utils.formatMoney(row.surcharge)} VNĐ
                                                                        </td>
                                                                        <td style={{textAlign: "left", color: '#35c21e'}} scope="row">
                                                                            {Utils.formatMoney(row.payment)} VNĐ
                                                                        </td>
                                                                        <td style={{textAlign: "center"}} scope="row">
                                                                            {row.createdAt ? moment(row.createdAt).format('DD-MM-YYYY') : 'Chưa có dữ liệu'}
                                                                        </td>
                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                            {row.note}
                                                                        </td>
                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                            {row.paymentType == "NHAN_TIEN"?"Nhận tiền": "Trả tiền"}
                                                                        </td>
                                                                        <td style={{textAlign: "left"}} scope="row">
                                                                            {row.paymentServiceTypeState=="PARTIAL_PAYMENT" ? <span className="badge badge-info" style={{color: "white"}}>Thanh toán một phần</span>:row.paymentServiceTypeState=="CANCEL"?<span className="badge badge-danger" style={{color: "white"}}>Hủy thanh toán</span> : <span className="badge badge-success" style={{color: "white"}}>Hoành thành</span>}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                                </tbody>
                                                            )}
                                                        </table>
                                                    </table>
                                                </div>
                                                <div className="pagination-right">
                                                    <Pagination
                                                        activePage={this.state.pageNumberPayment}
                                                        itemsCountPerPage={this.state.pageSizePayment}
                                                        totalItemsCount={this.state.totalItemPayment}
                                                        changeHandler={page => this.handleChangePagePayment(page)}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(CreateInvoiceManagement)
